import React from 'react'
/* import './HomeScreen.css' */
import NavBar from '../Components/Navbar';
import Banner from '../Components/Banner';
import Home from '../Components/Home';
import Footer from '../Components/Footer';

function HomeScreen () {
  return (
    <div className='ServiceScreen'>
      <NavBar />
      <Banner />
      <Home />
      <Footer />
    </div>
  )
}

export default HomeScreen;